/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { z } from 'zod/v4'

export const putProjectsProjectidPreferencesPipeSeriesPathProjectIdSchema = z.string()

export const putProjectsProjectidPreferencesPipeSeriesStatus200Schema = z.union([
  z.strictObject({
    pipe: z.object({
      internalDiameter: z.number().describe('The internal diameter of the pipe in millimeters').meta({ examples: [100] }),
      maxPressure: z.number().describe('The maximum pressure the pipe can withstand in bar').meta({ examples: [10] }),
      maxTemperature: z.number().describe('The maximum temperature the pipe can withstand in Celsius').meta({ examples: [120] }),
      name: z.string().describe('The name of the pipe').meta({ examples: ['Pipe 1'] }),
      roughness: z.number().describe('The roughness of the pipe in micrometers').meta({ examples: [50] }),
      valveSize: z.string().describe('The size of the valve associated with the pipe').meta({ examples: ['DN_10'] }),
      id: z.string().describe('Unique identifier').meta({ examples: [1] }),
    }).nullable().describe('The pipe associated with the preference'),
    pipeSeries: z.object({
      id: z.string().describe('Unique identifier').meta({ examples: [1] }),
      name: z.string().describe('The name of the pipe series').meta({ examples: ['Custom Pipe Series 1'] }),
    }).nullable().describe('The pipe series associated with the preference'),
    pipeSeriesSource: z.enum(['custom']),
  }),
  z.strictObject({
    pipeId: z.string().nullable().describe('The ID of the pipe to use').meta({ examples: [1] }),
    pipeSeriesId: z.string().nullable().describe('The ID of the pipe series to use').meta({ examples: [1] }),
    pipeSeriesSource: z.enum(['engine']),
  }),
  z.null(),
])

export const putProjectsProjectidPreferencesPipeSeriesStatus400Schema = z.string()

export const putProjectsProjectidPreferencesPipeSeriesStatus401Schema = z.string()

export const putProjectsProjectidPreferencesPipeSeriesStatus500Schema = z.string()

export const putProjectsProjectidPreferencesPipeSeriesResponseSchema = putProjectsProjectidPreferencesPipeSeriesStatus200Schema

export const putProjectsProjectidPreferencesPipeSeriesErrorSchema = z.union([putProjectsProjectidPreferencesPipeSeriesStatus400Schema, putProjectsProjectidPreferencesPipeSeriesStatus401Schema, putProjectsProjectidPreferencesPipeSeriesStatus500Schema])

export const putProjectsProjectidPreferencesPipeSeriesBodySchema = z.object({
  pipeId: z.string().nullable().describe('The ID of the pipe to use').meta({ examples: [1] }),
  pipeSeriesId: z.string().nullable().describe('The ID of the pipe series to use').meta({ examples: [1] }),
  pipeSeriesSource: z.union([z.enum(['engine']), z.enum(['custom'])]),
}).optional()

export const putProjectsProjectidPreferencesPipeSeriesPathSchema = z.object({
  projectId: z.string(),
})
